import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '1.25rem'
  },

  topRow: {
    display: 'flex'
  },

  bottomRow: {
    display: 'flex',
    marginRight: '48px'
  },

  avatar: {
    margin: '0 10px',
    padding: '0.125rem',
    width: '2rem',
    height: '2rem',
    fontSize: theme.size.sm,

    '& > img': {
      borderRadius: '100%'
    }
  },

  taskRoot: {
    border: '1px solid #C6C6C6',
    borderRadius: '8px',
    boxSizing: 'border-box',
    width: '100%',
    backgroundColor: 'white',
    maxWidth: '360px',
    padding: 12
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    // @ts-expect-error Prop exists
    paddingBottom: ({ expanded }) => expanded && 6
  },

  titleSection: {
    display: 'flex',
    width: '90%'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    marginRight: '10px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& svg': {
      marginLeft: 6,
      cursor: 'pointer',
      marginBottom: '-1px'
    }
  },

  contentArea: {
    overflow: 'hidden',
    maxHeight: '1000000px',

    '&[aria-expanded="true"]': {
      maxHeight: '0px'
    }
  },

  infoArea: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '0.5rem'
  },

  dataArea: {
    paddingTop: 6,
    borderTop: 'solid 1px #C6C6C6'
  },

  contentAreaRow: {
    display: 'grid',
    gridTemplateColumns: `minmax(20px, 1fr) minmax(20px, 1fr)`,
    alignItems: 'center',
    margin: '0.5rem 0px',
    gridGap: '0.5rem',
    minHeight: 28
  },

  contentAreaLabel: {
    display: 'flex',
    alignItems: 'center'
  },

  baseLine: {
    alignSelf: 'baseline'
  },

  daySoon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${theme.border.outline}`,
    borderRadius: '5px',
    boxSizing: 'border-box',
    padding: '0 0.118rem',
    cursor: 'pointer',
    height: 28,

    '& label': {
      marginLeft: '0.5rem',
      marginRight: '0.5rem',
      fontSize: theme.size.sm,
      color: theme.palette.textAlt,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      cursor: 'inherit'
    }
  },

  topRoot: {
    display: 'flex',
    margin: '6px 0.7rem 0 0',
    fontSize: theme.size.sm,
    color: '#8F8F8F',

    '& .creator': {
      marginRight: '4px'
    },

    '& .icon': {
      marginTop: '2px'
    },

    '& .time': {}
  },

  expandCollapseSection: {
    display: 'flex',
    cursor: 'pointer',
    // @ts-expect-error Prop exists
    transform: ({ expanded }) => (expanded ? `rotate(180deg)` : `rotate(0deg)`),
    transition: `transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`
  },

  contentLabel: {
    color: 'grey',
    marginLeft: 6
  },

  dropdown: {
    '& *': {
      fontSize: theme.size.sm
    }
  },

  asignedToRoot: {
    display: 'flex',
    alignItems: 'center'
  },

  seeDetails: {
    marginTop: 12,
    color: '#8F8F8F',
    cursor: 'pointer'
  },

  additionalAsignees: {
    marginLeft: 6,
    cursor: 'default'
  },

  asigneeSearch: {
    marginTop: 6,
    outline: '0',
    border: '0',
    paddingBottom: 6,
    fontSize: theme.size.sm,
    borderBottom: 'solid 1px lightgrey',
    paddingRight: 20,
    width: '90%'
  },

  asigneeSearchCloseBtn: {
    position: 'absolute',
    cursor: 'pointer',
    right: '0'
  },

  addAsigneeBtn: {
    marginLeft: 'auto',
    cursor: 'pointer'
  },

  addAssigneContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },

  menu: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '1px solid #EAEAEA',
    boxSizing: 'border-box',
    borderRadius: '7px',
    boxShadow: '0 20px 30px rgba(0, 0, 0, 0.15)',
    padding: '18px',
    background: 'white',
    minWidth: 400,
    maxHeight: 300
  },

  menuLabel: {
    color: 'grey',
    margin: '0.5rem 0.5rem',
    cursor: 'default'
  },

  items: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '2px',
    overflow: 'hidden auto',

    '& > :not(:last-child)': {
      marginBottom: '2px'
    },

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.buttonBG
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  item: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    fontSize: theme.size.sm,
    color: '#3C425B',
    cursor: 'pointer',
    transition: 'all 200ms',
    borderRadius: '8px',
    marginLeft: 6,

    '&:hover': {
      background: '#F5F6F8'
    },

    '& label': {
      marginLeft: 12,
      color: '#3C425B',
      fontSize: theme.size.sm,
      cursor: 'inherit'
    }
  },
  noShrink: {
    flexShrink: 0
  }
}))

export default useStyles
